export default {
  creditCardOptions: {
    data: null,
    error: null,
    loading: false,
  },
  createCreditCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  creditCardList: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  changeCreditCardPin: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  activateCreditCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  enableCreditCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  deleteCreditCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
};
